import React, { Component } from 'react';
import { Modal, Button, Alert, Popconfirm } from 'antd';
import { getDistance } from 'geolib';
import { withAsyncActions } from 'react-async-client';

import { GEOPOSITION_ERRORS } from 'constants/geoposition';
import Spinner from 'components/common/Spinner';
import { isCoordsCorrect } from 'utils/coordsValidate';
import { MAX_DISTANCE } from 'constants/geoposition';
import DistanceTag from '../common/cards/DistanceTag';
import { putCheckin, postCheckin } from 'actions/asyncActions';

@withAsyncActions(() => ({
    putCheckin,
    postCheckin
}))
export default class CoordinatesLoader extends Component {
    constructor() {
        super();

        this.state = {
            latitude: null,
            longitude: null,
            showAcceptButton: false,
            error: null
        };
    }

    componentDidMount() {
        this.reload();
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    onSuccess(coordinates) {
        const { params: { onSuccess }} = this.props;

        onSuccess(coordinates);
    }

    load() {
        if ('geolocation' in navigator) {
            setTimeout(() => this.toggleShowButton(), 5 * 1000);

            navigator.geolocation.getCurrentPosition(
                ({ coords }) => this.setCoordinates(coords.latitude, coords.longitude, { timeout: 10000 }),
                error => this.setState({
                    error: GEOPOSITION_ERRORS[error.code] || `${GEOPOSITION_ERRORS.error}: ${error.code}`
                })
            );
        } else {
            this.setState({
                error: GEOPOSITION_ERRORS.error,
            });
        }

        this.timer = setTimeout(() => this.toggleShowButton(), 10000);
    }

    setCoordinates = (latitude, longitude) => {
        this.setState({ latitude, longitude });
    }

    reload = () => {
        this.setState({ error: null });
        this.toggleShowButton(false);
        this.setCoordinates();
        this.load();
    }

    toggleShowButton = (showAcceptButton = true) => {
        this.setState({ showAcceptButton });
    }

    renderFooter() {
        return <Button type='primary' onClick={this.reload}>Обновить</Button>;
    }

    renderWithCoords = () => {
        const { params: { shopCoords = {}, checkout }, putCheckin, postCheckin } = this.props;
        const { longitude, latitude } = this.state;
        const coords = { longitude, latitude };
        const isCorrect = isCoordsCorrect(coords) && isCoordsCorrect(shopCoords);

        const distance = isCorrect && getDistance(coords, shopCoords, 1);

        if (distance > MAX_DISTANCE) {
            return <div>
                <Alert className='text-center' type='warning' message='Координаты не совпали' />
                <br />
                <p>
                    Расстояние до магазина
                    <DistanceTag className="ml10" distance={distance} />
                </p>
                { checkout ?
                    <Popconfirm
                        title='Вы уверены, что хотите выйти из чекина?'
                        okText='Да'
                        cancelText='Нет'
                        onConfirm={() => this.onSuccess(coords)}
                        placement='bottom'>
                        <Button disabled={putCheckin.meta.pending || postCheckin.meta.pending}>
                            Все равно выйти
                        </Button>
                    </Popconfirm> :
                    <Button onClick={() => this.onSuccess(coords)} disabled={putCheckin.meta.pending || postCheckin.meta.pending}>
                        Все равно отметиться
                    </Button>

                }
            </div>
        } else {
            return <div>
                {isCorrect ?
                    <Alert className='text-center' message='Вы в магазине' type='success' showIcon />
                    : <Alert className='text-center' type='warning' message='Координаты некорректные' />
                }
                <br />
                { checkout ?
                    <Popconfirm
                        title='Вы уверены, что хотите выйти из чекина?'
                        okText='Да'
                        cancelText='Нет'
                        onConfirm={() => this.onSuccess(coords)}
                        placement='bottom'>
                        <Button disabled={putCheckin.meta.pending || postCheckin.meta.pending}>
                            Выйти
                        </Button>
                    </Popconfirm> :
                    <Button onClick={() => this.onSuccess(coords)} disabled={putCheckin.meta.pending || postCheckin.meta.pending}>
                        Отметиться
                    </Button>
                }
            </div>;
        }
    }

    render() {
        const { modal, params: { checkout }, putCheckin, postCheckin } = this.props;
        const { showAcceptButton, error, longitude, latitude } = this.state;

        return (
            <Modal
                {...modal}
                className='text-center coordinates-loader'
                width={350}
                footer={this.renderFooter()}
            >
                { longitude && latitude ? (
                    this.renderWithCoords()
                ) : (
                    <div>
                        {error ? (
                            <div>
                                <Alert className='text-center' type='error' message={error} />
                                <br />
                            </div>
                        ) : (
                            <div>
                                <div>Получаем геопозицию...</div>
                                <Spinner />
                            </div>
                        )}
                        { checkout ?
                            <Popconfirm
                                title='Вы уверены, что хотите выйти из чекина?'
                                okText='Да'
                                cancelText='Нет'
                                onConfirm={() => this.onSuccess({})}
                                placement='bottom'>
                                <Button disabled={!(showAcceptButton || error) || putCheckin.meta.pending || postCheckin.meta.pending}>
                                    Выйти без координат
                                </Button>
                            </Popconfirm> :
                            <Button onClick={() => this.onSuccess({})} disabled={!(showAcceptButton || error) || putCheckin.meta.pending || postCheckin.meta.pending}>
                                Отметиться без координат
                            </Button>
                        }
                    </div>
                )}
            </Modal>
        );
    }
}
